import { render, staticRenderFns } from "./titleMix.vue?vue&type=template&id=c6a204d8"
import script from "./titleMix.vue?vue&type=script&lang=js"
export * from "./titleMix.vue?vue&type=script&lang=js"
import style0 from "./titleMix.vue?vue&type=style&index=0&id=c6a204d8&prod&lang=scss&scope=true"
import style1 from "./titleMix.vue?vue&type=style&index=1&id=c6a204d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports